import script from "./AppFooterSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFooterSignature.vue?vue&type=script&setup=true&lang=js"

import "./AppFooterSignature.vue?vue&type=style&index=0&id=4f4fee25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4fee25"]])

export default __exports__